import React from 'react'
import { Alert } from 'react-bootstrap'
import { ReactComponent as InfoIcon } from '../../assets/images/info.svg'
import './styles.scss'

interface InfoAlertProps {
  message: string
  limitWidth?: boolean
  variant: 'info' | 'error' | 'warning'
}

const getIconByVariant = (variant: InfoAlertProps['variant']) => {
  switch (variant) {
    case 'info':
    default:
      return <InfoIcon className="mt-1 flex-shrink-0" title="info" />
  }
}

export const Banner: React.FC<InfoAlertProps> = ({
  message,
  variant,
  limitWidth = false,
}) => {
  return (
    <Alert
      className={`info-banner info-banner--${variant} d-flex align-items-start gap-2 border-0 p-3 m-0 ${
        limitWidth ? 'w-700px' : ''
      }`}
    >
      {getIconByVariant(variant)}
      <p className="m-0">{message}</p>
    </Alert>
  )
}
